export const getAgentInstallCommand = serverId =>
    `wget -q https://raw.githubusercontent.com/syagent/agent-2/main/install.sh && sudo bash install.sh ${ serverId }`;
